import { Text } from "retro-react";
import React from "react";


export const AboutBio  = ({ pBio }) => {
    
    return(
    <Text variant="paragraph">
        {pBio.split('\r\n\r\n').map((paragraph, index) => (
            <p key={index}>{paragraph}</p>
        ))}
    </Text>
    );

}